module.exports = __webpack_public_path__ + "img/IMG_9621_L_WoodMatted.048d10de.jpg";